const muralRoutes = [
  // Boleto
  {
    path: '/avisos',
    name: 'mural-list',
    component: () => import('@/views/mural/MuralDashboard.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Avisos', active: true },
      ],
    },
  },
  {
    path: '/aviso/:id',
    name: 'aviso-view',
    component: () => import('@/views/mural/AvisoView.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Avisos', url: '/avisos' },
        { title: 'Visualizar', active: true },
      ],
    },
  },
]

export default muralRoutes
